module.exports = __webpack_public_path__ + "img/ico202.c2240960.svg";